// Auth

export const rootPath = '/'
export const loginPath = '/login'

// Public (unauthenticated) account-recovery + invite acceptance.
// `:token` is the raw reset/invite token from the emailed link; the backend
// stores only its hash, so it never appears in any API response.
export const forgotPasswordPath = '/forgot-password'
export const acceptInvitePath = '/accept-invite/:token'
export const resetPasswordPath = '/reset-password/:token'

// Subscribers

export const subscribersPath = '/subscribers'
export const subscriberDetailsPath = '/subscriber-details/:id'

// Subscription

export const subscriptionPath = '/subscription'

// Subscription metrics (MRR, trials, retention)

export const subscriptionMetricsPath = '/subscription-metrics'

// AI Spend (fleet AI usage)

export const aiSpendPath = '/ai-spend'

// PWP Assistant config (SuperAdmin only)

export const assistantConfigPath = '/assistant-config'

// Admin

export const adminPath = '/admin'

// Support

export const supportPath = '/support'
export const impersonationAuditPath = '/impersonation-audit'

// Settings

export const settingsPath = '/settings'
export const settingsSessionsPath = '/settings/sessions'

// Status

export const statusPath = '/status'
export const status404Path = '/status/404'
